import React from "react";
import { useUserAndGameContext } from "../../contexts/UserAndGameContext";
import { useGolfLeagueContext } from "./context/GolfLeagueContext";
import { Box, Typography, Button } from '@mui/material';
import TeamPage from "./TeamsPage/TeamPage";
import LeaderboardPage from "./LeaderboardPage/LeaderboardPage";
import EventsPage from "./EventsPage/EventsPage";
import RosterPage from "./TeamsPage/RosterPage";
import GameNavBar from "../../components/NavigationBars/GameNavigationBar/GameNavBarVersionTwo";
import SponsorTab from "../SponsorTab/SponsorTab";
import GameRulesPage from "../GameRulesPage/GameRulesPage";
import NewGameHomePage from "../NewGameHomePage/NewGameHomePage";
import SnackBarWithMenu from "../GamePageComponents/SnackBar/SnackBarWithMenu";
import GameRulesPageNew from "../GameRulesPage/GameRulesPageNew";
import ScoreEntry from "./ScoreEntry/ScoreEntryPage";
import TemplatedGameHomePage from "../NewGameHomePage/TemplatedGameHomePage";
import TemplatedSnackbarWithMenu from "../GamePageComponents/SnackBar/TemplatedSnackbarWithMenu";

const GolfLeagueContainer = () => {

    const {
        page,
        gameData,
    } = useUserAndGameContext();

    const { test } = useGolfLeagueContext();

    return (
        <>
            {gameData?.gameSnackbarInfo && (
                <TemplatedSnackbarWithMenu />
            )}
            {/* {page === "home"?
                <>
                    
                    <Box
                        sx={{
                            backgroundImage: 'url(https://poolpartyfilestorage.blob.core.windows.net/media/tri-state-pga-banner-bg.png)',
                            height: '480px',
                            width:'100%',
                            backgroundSize:'cover',
                            backgroundRepeat:'no-repeat',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}
                    >
                        <img style={{
                            maxWidth:'375px',
                            margin:'0 auto',
                            display:'block',

                        }} src="https://poolpartyfilestorage.blob.core.windows.net/media/TriStateNewLogo.png" alt="tri-state-pga-banner"/>
                    </Box>
                </>
                :
                <Box
                    sx={{
                        backgroundImage: 'url(https://poolpartyfilestorage.blob.core.windows.net/media/tri-state-pga-banner-bg.png)',
                        height: '180px',
                        width:'100%',
                        backgroundSize:'cover',
                        backgroundRepeat:'no-repeat',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <img style={{
                        maxHeight: '160px',
                        maxWidth:'375px',
                        margin:'0 auto',
                        display:'block',

                    }} src="https://poolpartyfilestorage.blob.core.windows.net/media/TriStateHeroLogoSmall.png" alt="tri-state-pga-banner"/>
                </Box>
            } */}

            <GameNavBar />

            {page === "home" && (
                <TemplatedGameHomePage />
            )}

            {page === "teams" && (
                <TeamPage />
            )}

            {page === "roster" && (
                <RosterPage />
            )}

            {page === "events" && (
                <EventsPage />
            )}

            {page === "leaderboard" && (
                <LeaderboardPage />
            )}

            {page === "sponsor" && (
                <SponsorTab gameData={gameData} />
            )}

            {page === "rules" && (
                <GameRulesPageNew />
            )}

            {page === "score-entry" && (
                <ScoreEntry />
            )}


        </>
    );
};

export default GolfLeagueContainer;